import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import useRedirect from '@sprinx/react-routes/useRedirect';
import AnchorContainer from '../AnchorContainer';
var useStyles = makeStyles(function () {
  return (
    /* theme */
    {
      root: {
        display: 'flex',
        flexDirection: 'column'
      }
    }
  );
}, {
  name: 'SxComProductDetailSpagettyItem'
});
var ProductDetailSpagettyItem = /*#__PURE__*/React.forwardRef(function ProductDetailSpagettyItem(_ref, ref) {
  var activeZoneOffset = _ref.activeZoneOffset,
      children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      collapsable = _ref.collapsable,
      pCollapsed = _ref.collapsed,
      noActiveZone = _ref.noActiveZone,
      renderToAnchor = _ref.renderToAnchor,
      rest = _objectWithoutProperties(_ref, ["activeZoneOffset", "children", "classes", "className", "collapsable", "collapsed", "noActiveZone", "renderToAnchor"]);

  var classes = useStyles({
    classes: pClasses
  });

  var _React$useState = React.useState(pCollapsed),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      collapsed = _React$useState2[0],
      setCollapsed = _React$useState2[1];

  var innerRef = React.useRef();
  var setRedirect = useRedirect();
  React.useImperativeHandle(ref, function () {
    return {
      offsetTop: innerRef.current.offsetTop,
      offsetBottom: innerRef.current.offsetHeight
    };
  });
  var handleToggleCollapse = React.useCallback(function (v) {
    setCollapsed(typeof v === 'boolean' ? v : function (ps) {
      return !ps;
    });
  }, []);
  React.useEffect(function () {
    setCollapsed(pCollapsed);
  }, [pCollapsed]);
  var handleCheckPosition = React.useCallback(function () {
    var offsetTop = innerRef && innerRef.current && innerRef.current.offsetTop - activeZoneOffset;
    var offsetBottom = innerRef && innerRef.current && innerRef.current.offsetHeight + offsetTop - 8;
    var windowPosition = window.pageYOffset;

    if (offsetTop <= windowPosition && offsetBottom >= windowPosition) {
      if (window.location.hash !== "#".concat(renderToAnchor)) {
        setRedirect({
          hash: renderToAnchor
        }, {}, false);
      }
    }
  }, [activeZoneOffset, renderToAnchor, setRedirect]);
  React.useEffect(function () {
    if (typeof window !== 'undefined' && !noActiveZone) {
      window.addEventListener('scroll', handleCheckPosition);
      return function () {
        window.removeEventListener('scroll', handleCheckPosition);
      };
    }

    return undefined;
  }, [handleCheckPosition, noActiveZone]);
  return /*#__PURE__*/React.createElement(AnchorContainer, _extends({}, rest, {
    className: clsx(classes.root, className),
    renderToAnchor: renderToAnchor,
    ref: innerRef
  }), children({
    onToggleCollapse: collapsable ? handleToggleCollapse : undefined,
    collapsed: collapsed
  }));
});
ProductDetailSpagettyItem.propTypes = {
  activeZoneOffset: PropTypes.number,
  children: PropTypes.func,
  classes: PropTypes.shape({
    root: PropTypes.string
  }),
  className: PropTypes.string,
  collapsable: PropTypes.bool,
  collapsed: PropTypes.bool,
  noActiveZone: PropTypes.bool,
  renderToAnchor: PropTypes.string
};
ProductDetailSpagettyItem.defaultProps = {
  activeZoneOffset: 8,
  children: undefined,
  classes: undefined,
  className: undefined,
  collapsable: false,
  collapsed: false,
  noActiveZone: false,
  renderToAnchor: 'description'
};
export default ProductDetailSpagettyItem;